var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 6.72,
    fill: "#1778F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3251 16.4998L16.3601 20.5348L24.4301 12.4648M7.56982 16.4998L11.6048 20.5348M16.6049 15.5628L19.6748 12.4648",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadOverview);
export default __webpack_public_path__ + "static/media/read-overview.f6c7e92e4c9a354f63abdfb7f5a6ed77.svg";
export { ForwardRef as ReactComponent };